const API_BASE = process.env.REACT_APP_API_BASE || 'https://mzcd0ywjhc.execute-api.eu-north-1.amazonaws.com/attraxion-API';

async function request(path, options = {}) {
  const response = await fetch(`${API_BASE}${path}`, {
    headers: { 'Content-Type': 'application/json', ...options.headers },
    ...options
  });
  // On an error status a non-JSON body must not mask the status; on success it still throws.
  const data = await response.json().catch((e) => { if (response.ok) throw e; return null; });
  if (!response.ok) {
    // Keep status + body so callers can read flags such as 409 { pending: true }.
    throw Object.assign(new Error((data && data.error) || 'Request failed'), { status: response.status, body: data });
  }
  return data;
}

export const fetchMenu = (venueId, checkoutId) => {
  let url = `/online/menu?venue=${venueId}`;
  if (checkoutId) url += `&checkout=${checkoutId}`;
  return request(url);
};
export const placeOrder = (orderData) => request('/online/order', { method: 'POST', body: JSON.stringify(orderData) });
export const getOrderStatus = (orderId, sessionToken) => request(`/online/order/${orderId}/status?token=${sessionToken}`);
export const cancelOrder = (orderId, sessionToken) => request(`/online/order/${orderId}/cancel?token=${sessionToken}`, { method: 'POST' });
export const memberLookup = (venueId, contact) => request('/online/member/lookup', { method: 'POST', body: JSON.stringify({ venue_id: venueId, contact }) });
export const memberVerify = (venueId, contact, otpCode) => request('/online/member/verify', { method: 'POST', body: JSON.stringify({ venue_id: venueId, contact, otp_code: otpCode }) });
export const createPaymentSession = (data) =>
  request('/online/payment/session', { method: 'POST', body: JSON.stringify(data) });
export const completePayment = (data) =>
  request('/online/payment/complete', { method: 'POST', body: JSON.stringify(data) });
export const refreshPaymentSession = (payment_reference) =>
  request('/online/payment/session', { method: 'POST', body: JSON.stringify({ refresh: true, payment_reference }) });
